module.exports = __webpack_public_path__ + "static/media/LANDING.ee7b2b54.png";